import api from '../services/api';
import { ObligationPage, ObligationRow } from './monthlyInvoiceView';

export function fetchObligationPage(
  competence: string,
  page: number,
  limit: number,
): Promise<ObligationPage> {
  return api
    .get<ObligationPage>('/timeclock/hr/invoice-obligations', {
      params: { competence, page, limit },
    })
    .then((response) => response.data);
}

export function fetchMyObligation(competence: string): Promise<ObligationRow> {
  return api
    .get<ObligationRow>('/timeclock/my/invoice-obligation', { params: { competence } })
    .then((response) => response.data);
}

export function fetchInvoiceEvents(invoiceId: string, scope: 'review' | 'mine') {
  const path =
    scope === 'review'
      ? `/timeclock/hr/invoices/${invoiceId}/events`
      : `/timeclock/my/invoices/${invoiceId}/events`;
  return api.get<Array<{ id: string; type: string; actorName: string; createdAt: string }>>(path).then(
    (response) => response.data,
  );
}
